import { render, staticRenderFns } from "./MessageStorage.vue?vue&type=template&id=703c2925&scoped=true"
import script from "./MessageStorage.vue?vue&type=script&lang=js"
export * from "./MessageStorage.vue?vue&type=script&lang=js"
import style0 from "./MessageStorage.vue?vue&type=style&index=0&id=703c2925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c2925",
  null
  
)

export default component.exports